import type { Policy } from './components';
import type { ResponseError } from './types';

export const hasErrorForField = (error: ResponseError | null, field: string) =>
    !!error && !!error.violations && field in error.violations;

type GetErrorForFieldType = (error: ResponseError | null, field: string) => string[] | undefined;

export const getErrorForField: GetErrorForFieldType = (error: ResponseError | null, field) =>
    error?.violations?.[field];

export const isCommonError = (error: Pick<ResponseError, 'violations'> | null): error is ResponseError =>
    !!error && !error.violations;

// add default policy: password can't match email
export const getPolicy = (policy: Policy): Policy => ({ ...policy, matchesEmail: 'true' });
